import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import { BRAND_LOGO_URL, TAB_DISPLAY_NAME } from '../constants/bookingConst';
import '../css/PosWelcome.css';

/**
 * Shown at /<client-id> when no such client is registered.
 *
 * Deliberately says the address is unknown rather than offering a sign-in
 * form: a form here would be a dead end that looks like a live till, and
 * whoever arrived would blame their password rather than the link.
 *
 * It does NOT list the clients that do exist — that would turn a mistyped URL
 * into a directory of every club using the system.
 *
 * @param {object} props
 * @param {string} props.clientId - the unrecognised id, echoed so the reader
 *   can see the typo without going back to the address bar.
 * @returns {JSX.Element}
 */
function PosClientNotFound({ clientId }) {
  return (
    <div className="pw-page pw-page-centered">
      <div className="pw-notfound">
        <BrandLogo src={BRAND_LOGO_URL} alt={TAB_DISPLAY_NAME} className="pw-notfound-logo" />
        <p className="pw-eyebrow">Point of Sale</p>
        <h1 className="pw-notfound-title">No till at this address</h1>
        <p className="pw-notfound-body">
          There is no client registered as <code className="pw-code">{clientId}</code>.
          Check the link, or ask your administrator for the right one.
        </p>
        <Link className="pw-btn pw-btn-primary" to="/">Back to {TAB_DISPLAY_NAME}</Link>
      </div>
    </div>
  );
}

export default PosClientNotFound;
